export class CognitiveReportData {
    jobScore: number;
    jobTitle: string;
    firstName: string;
    lastName: string;
    personScore: number;
    assessmentDate: string;
    matchScore: number;
    // raw score details
    totalAttempted: number;
    totalCorrect: number;
    subScoreVAttempted: number;
    subScoreVCorrect: number;
    subScoreNAttempted: number;
    subScoreNCorrect: number;
    subScoreRAttempted: number;
    subScoreRCorrect: number;
    // show or hide sensitive data - ie stuff to not show the assessment taker
    showSensitiveInformation = true;

    constructor(startingValues?: any) {
        // TODO this should probably be replaced by a factory
        Object.assign(this, startingValues);
    }
}
